import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { IErrorPageData } from "./interfaces";

@Injectable({ providedIn: "root" })
export class ErrorPageService {
    private _errorPageShow$: BehaviorSubject<IErrorPageData | undefined> = new BehaviorSubject(undefined);

    showErrorPage(data?: IErrorPageData): void {
        this._errorPageShow$.next(data);
    }

    subscribeShowErrorPage(): Observable<IErrorPageData | undefined> {
        return this._errorPageShow$.asObservable();
    }
}
